import React, { useState } from 'react';
import Modal from './ModalProps'; // Modal 컴포넌트 경로 확인

interface TermsConditionsProps {
  onAdvance: (consents: { [key: string]: boolean }) => void;
  onGoBack: () => void;
}

const options = [
  {
    value: 'option1',
    label: '이용 약관',
    type: '[필수]',
    required: true,
    content: `제1조(목적)
    Creait(이하 '회사')는 이용자의 개인정보를 보호하기 위해 관련 법령을 준수하며, 개인정보 보호 방침을 수립합니다.

    제2조(개인정보 처리 원칙)
    회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 법령에 의해 강제되는 경우, 사전 동의 없이 제공할 수 있습니다.

    '서비스'란 회사가 제공하는 모든 온라인 서비스(PC, TV, 모바일 등에서 접근 가능)를 의미합니다.
    '이용자'란 서비스에 접속하여 이용하는 개인회원, 기업회원 및 비회원 모두를 말합니다.
    '개인회원'은 개인 정보 제공 후 회원 가입을 완료한 자를 의미합니다.
    '기업회원'은 기업 정보를 제공 후 회원 가입을 완료한 자를 의미합니다.
    '비회원'은 회원 가입 없이 서비스를 이용하는 자를 말합니다.
    '아이디(ID)'란 회원 식별을 위해 회사가 승인한 문자와 숫자의 조합을 의미합니다.
    '비밀번호'란 아이디와 일치성을 확인하고 비밀 보호를 위한 문자와 숫자의 조합을 의미합니다.
    '유료서비스'란 회사가 유료로 제공하는 서비스입니다.
    '결제'란 유료서비스를 이용하기 위한 지불 행위를 의미합니다.
    '할인쿠폰'은 회사가 발행 및 관리하는 지급 수단을 의미합니다.
    '콘텐츠'란 정보통신망을 통해 제공되는 정보 형태의 글, 사진, 동영상 등을 의미합니다.`,
  },
  {
    value: 'option2',
    label: '개인정보 처리 방침',
    type: '[필수]',
    required: true,
    content: `제1조(목적)
    Creait(이하 '회사')는 이용자의 개인정보를 보호하기 위해 관련 법령을 준수하며, 개인정보 보호 방침을 수립합니다.

    제2조(개인정보 처리 원칙)
    회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 법령에 의해 강제되는 경우, 사전 동의 없이 제공할 수 있습니다.

    제3조(개인정보 처리 방침의 공개 및 변경)
    회사는 개인정보 처리 방침을 홈페이지에 공개하며, 변경 시 7일 전 공지합니다. 중요 변경 사항은 30일 전에 공지합니다.

    제4조(회원 가입 및 결제 정보)
    회원 가입 시 이메일 주소, 비밀번호, 닉네임을 수집합니다. 결제 서비스 제공을 위해 카드번호, 은행명, 계좌번호를 수집합니다.

    제5조(서비스 제공을 위한 정보)
    서비스 제공을 위한 기본 정보로 이메일 주소를 수집합니다.
    이메일 주소를 통해 서비스 이용에 필요한 알림 및 안내를 제공합니다.
    서비스 개선 및 사용자 맞춤형 경험 제공을 위해 수집된 이메일 주소를 활용할 수 있습니다.

    제6조(부정 이용 확인 및 통계 분석)
    서비스 이용 기록을 수집하여 부정 이용을 확인하고 통계를 분석합니다.

    제7조(개인정보 보유 및 이용 기간)
    개인정보는 목적 달성 시까지 보유하며, 서비스 부정 이용 기록은 회원 탈퇴 후 1년간 보관합니다. 법령에 따라 다른 기간도 적용될 수 있습니다.

    제8조(개인정보 파기)
    개인정보는 목적 달성 후 지체 없이 파기합니다. 전자파일은 기술적 방법으로 삭제하며, 종이는 분쇄합니다.

    제9조(광고성 정보의 전송)
    광고성 정보는 이용자의 사전 동의를 받은 후 전송하며, 수신 거부 의사를 표시할 수 있습니다. 오후 9시부터 다음 날 오전 8시까지는 별도의 동의가 필요합니다.

    제10조(개인정보 조회 및 수정)
    이용자는 자신의 개인정보를 조회하거나 수정할 수 있으며, 개인정보 수집 동의를 철회할 수 있습니다. 정정 요청 시, 제3자에게 제공된 개인정보도 신속히 정정합니다.

    제11조(개인정보 유출 대응)
    개인정보 유출 시, 해당 이용자에게 알리고 관련 기관에 신고합니다. 연락처를 알 수 없는 경우, 홈페이지에 게시하여 통지합니다.

    제12조(국외 이전 개인정보 보호)
    국외로 개인정보를 제공할 경우 이용자의 동의를 받습니다. 이전되는 개인정보의 항목, 국가, 방법 등을 고지합니다.

    제13조(쿠키 사용)
    쿠키를 사용하여 이용 정보를 저장합니다. 웹브라우저 설정을 통해 쿠키 허용 여부를 선택할 수 있으며, 쿠키 저장을 거부할 경우 일부 서비스 이용에 제한이 있을 수 있습니다.

    제14조(개인정보 보호 책임자)
    • 이름: 신준 • 직책: 대표 • 전화번호: 010-5613-1571

    제15조(권익침해 구제 방법)
    개인정보 침해로 인한 구제를 원할 경우, 개인정보분쟁조정위원회 또는 한국인터넷진흥원 개인정보침해신고센터에 문의할 수 있습니다.`,
  },
  {
    value: 'option4',
    label: '마케팅을 위한 개인정보 수집/이용 동의',
    type: '[선택]',
    required: false,
    content: `마케팅을 위한 개인정보 수집/이용 동의 내용: 사용자의 동의를 바탕으로 마케팅 정보 및 혜택을 제공할 수 있습니다.`,
  },
];

const TermsConditions: React.FC<TermsConditionsProps> = ({
                                                           onAdvance,
                                                           onGoBack,
                                                         }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', content: '' });
  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleModalOpen = (title: string, content: string) => {
    setModalContent({ title, content });
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleCheckboxChange = (value: string) => {
    setCheckedItems((prevState) =>
      prevState.includes(value)
        ? prevState.filter((item) => item !== value)
        : [...prevState, value]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setCheckedItems([]);
    } else {
      setCheckedItems(options.map((option) => option.value));
    }
    setSelectAll(!selectAll);
  };

  const handleNext = () => {
    const allRequiredSelected = options
      .filter((option) => option.required)
      .every((option) => checkedItems.includes(option.value));

    if (allRequiredSelected) {
      // consents 객체 생성
      const consents: { [key: string]: boolean } = {};
      options.forEach((option) => {
        consents[option.value] = checkedItems.includes(option.value);
      });
      onAdvance(consents);
    } else {
      alert('모든 필수 항목에 동의하셔야 합니다.');
    }
  };

  return (
    <div className="bg-white px-8 mobile:px-4 py-6 rounded-lg shadow max-w-[600px] w-full mx-auto mt-[160px] mobile:mt-[160px] pb-[30px]">
      <h2 className="text-lg mobile:text-base text-center Pretendard-Bold tracking-wide mb-8">
        회원가입을 위한 약관동의를 진행해주세요.
      </h2>

      <form>
        <div className="flex items-center mb-4 border-b border-dashed pb-4">
          <input
            type="checkbox"
            id="selectAll"
            checked={selectAll}
            onChange={handleSelectAll}
            className="custom-checkbox"
          />
          <label htmlFor="selectAll" className="ml-2 text-[#111] text-sm Pretendard-Regular cursor-pointer">
            전체 약관 동의
          </label>
        </div>

        <fieldset className="space-y-4">
          {options.map((option, index) => (
            <div key={index} className="flex justify-between items-center">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id={`option${index}`}
                  name="terms"
                  value={option.value}
                  checked={checkedItems.includes(option.value)}
                  onChange={() => handleCheckboxChange(option.value)}
                  className="custom-checkbox"
                />
                <label
                  htmlFor={`option${index}`}
                  className="ml-2 text-[#111] text-sm cursor-pointer Pretendard-Regular mobile:text-[10px] mobile:w-[200px]"
                >
                  <span className="text-MainColor Pretendard-Regular">{option.type} </span>
                  {option.label}
                </label>
              </div>
              <button
                type="button"
                onClick={() => handleModalOpen(option.label, option.content)}
                className="text-MainColor border border-MainColor rounded-lg font-semibold py-1 px-3 mobile:px-0 w-[100px] mobile:text-[10px] mobile:w-[65px]"
              >
                내용보기
              </button>
            </div>
          ))}
        </fieldset>

        <div className='font-thin text-sm mobile:text-[10px] mt-6 leading-6 mobile:leading-4'>
          <p>※ 필수항목에 동의하지 않으실 경우 서비스 가입이 불가합니다.</p>
          <p>※ 선택 항목에 동의하지 않아도 서비스 가입은 가능하지만, 관련된 서비스 제공은 제한됩니다.</p>
        </div>

        <div className="flex justify-between mt-8">
          <button
            type="button"
            onClick={onGoBack}
            className="bg-gray-300 hover:bg-gray-400 mobile:text-sm text-white Pretendard-Bold py-2 px-8 mobile:px-4 rounded"
          >
            취소
          </button>
          <button
            type="button"
            onClick={handleNext}
            className="bg-MainColor hover:bg-opacity-80 mobile:text-sm text-white Pretendard-Bold py-2 px-8 mobile:px-4 rounded"
          >
            다음
          </button>
        </div>
      </form>

      {modalOpen && (
        <Modal
          title={modalContent.title}
          content={modalContent.content}
          onClose={handleModalClose}
          isOpen={modalOpen} // isOpen 속성 추가
        />
      )}
    </div>
  );
};

export default TermsConditions;
